export const darkTheme = {
 primaryColor: "#4e83ea",
 secondaryColor: "#354a75",
 textColor: "#efefef",
 error: "#F16767",

 bgColor: "#222526",
 bgColor2: "#30343C",
 bgColor3: "#434956",

 width: "1080px",

 titleDelay: "0.2",
};
